import o from "../../../rc-util/es/Dom/canUseDom.mjs";
import { useLayoutEffect as e, useEffect as f } from "react";
var a = o() ? e : f;
export {
  a as default
};
//# sourceMappingURL=useIsomorphicLayoutEffect2.mjs.map
